import React from 'react'
import Text from '../../shared/textStyleDefault/texto'
import constantes from '../../constantes/constantes'
import image1 from '../../../assets/images/gestionproductos/Ellipse 1.svg'
import image3 from '../../../assets/images/gestionproductos/Ellipse 2.svg'
import image2 from '../../../assets/images/gestionproductos/Ellipse 6.svg'

const lista = constantes.enfoque

const ListaEnfoque = (): any => {
  return (
    <div className='flex flex-col md:flex-row w-full md:w-[80%] pb-[54px] items-center justify-center max-w-[1230px] mx-auto px-1'>
        <div className='w-[50%] hidden md:block'>
            <div>
                <img src={image1} alt="" />
            </div>
            <div>
                <img src={image2} alt="" />
            </div>
            <div>
                <img src={image3} alt="" />
            </div>
        </div>
        <div className='flex flex-row w-screen h-[98px] md:hidden items-center justify-center mb-[40px]'>
            <div className='-ml-2 first:ml-0'>
                <img src={image1} alt="" className='h-[98px]' />
            </div>
            <div className='-ml-6'>
                <img src={image2} alt="" className='h-[98px]' />
            </div>
            <div className='-ml-6'>
                <img src={image3} alt="" className='h-[98px]' />
            </div>
        </div>
        <div className='w-[100%] md:w-[50%]'>
            {lista.map((enfoque) => (
                <div key={enfoque.icono} className="mb-6">
                <div className="flex items-center gap-2">
                <img src={enfoque.icono} alt="icono" className="w-6 h-6" />
                <Text as="h5" className='text-left md:whitespace-nowrap'>{enfoque.titulo}</Text>
                </div>
                <div className="mt-2">
                <Text variant="subtitle1" className='text-left'>{enfoque.texto}</Text>
                </div>
            </div>
            ))}
        </div>
    </div>
  )
}
export default ListaEnfoque
